import { render, staticRenderFns } from "./categoryTemplate.vue?vue&type=template&id=402b4070&scoped=true"
import script from "./categoryTemplate.vue?vue&type=script&lang=js"
export * from "./categoryTemplate.vue?vue&type=script&lang=js"
import style0 from "./categoryTemplate.vue?vue&type=style&index=0&id=402b4070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b4070",
  null
  
)

export default component.exports